export function getValueFromKey<T extends Record<string, any>>(path: string, obj: T): any {
  if (!obj) return '';
  return path ? path.split('.').reduce((acc, part) => acc && acc[part], obj) : obj;
}
